import { types } from './actions';

const initialState = {
  emailNotificationSettings: [],
  isLoading: false,
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.ADD_NEW_EMAIL_NOTIFICATION_SETTING_ERROR:
      return {
        ...state,
        isLoading: false,
      };
    case types.ADD_NEW_EMAIL_NOTIFICATION_SETTING_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case types.ADD_NEW_EMAIL_NOTIFICATION_SETTING_SUCCESS:
      return {
        ...state,
        emailNotificationSettings: [
          ...state.emailNotificationSettings,
          payload.emailNotificationSetting,
        ],
        isLoading: false,
      };
    case types.DELETE_EMAIL_NOTIFICATION_SETTING_ERROR:
      return {
        ...state,
        isLoading: false,
      };
    case types.DELETE_EMAIL_NOTIFICATION_SETTING_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case types.DELETE_EMAIL_NOTIFICATION_SETTING_SUCCESS:
      return {
        ...state,
        emailNotificationSettings: payload.emailNotificationSettings,
        isLoading: false,
      };
    case types.FETCH_GROUP_EMAIL_SETTINGS_SUCCESS:
      return {
        ...state,
        emailNotificationSettings: payload.emailNotificationSettings,
      };
    case types.UPDATE_GROUP_EMAIL_SETTINGS_ERROR:
      return {
        ...state,
        isLoading: false,
      };
    case types.UPDATE_GROUP_EMAIL_SETTINGS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case types.UPDATE_GROUP_EMAIL_SETTINGS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        emailNotificationSettings: payload.emailNotificationSettings,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.settings.company.emailNotifications;

export const getEmailNotificationSettings = (state) =>
  getScope(state).emailNotificationSettings;

export const getIsLoading = (state) => getScope(state).isLoading;
